/**
 * Which accounts have cloud LIMITS — not whether they sync.
 *
 * Until 16.09.2026 this held a per-account on/off switch for personal sync:
 * Settings → Plan on the desktop, a modal on first web sign-in. The cloud/
 * local model replaced it (owner decision, card C9). Sync is not a switch any
 * more; WHERE AN ITEM LIVES is the setting, chosen per board and per document:
 *
 *   - a cloud item syncs — web app, other devices;
 *   - a "this device" item never leaves the machine (the engine never even
 *     queues it: sync::item_location::is_device_scope);
 *   - a new item goes to the cloud while the plan has room and to this device
 *     once it does not (records/itemLocation.scopeForNewItem).
 *
 * That is strictly better than the switch it replaces: "off" used to mean a
 * Free user got nothing in the cloud and no web app, and the prompt asked them
 * to decide before they had anything to decide about.
 *
 * The stored `apiboo.personalSync.consent.<id>` keys are simply ignored — they
 * are per-device, they grant nothing, and reading them would only bring the
 * old behaviour back for whoever still has one.
 */

/** Plans whose cloud items are capped (Free). Paid plans are unlimited. */
export function isLimitedPlan(user) {
  return !user?.plan || user.plan === 'free';
}
